import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Resume = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Resume' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M1,20 L6,20 L6,4 L1,4 L1,20 Z M11,19.0000002 L22,12 L11,5 L11,19.0000002 Z' />
  </StyledIcon>
);
